import { render } from "./AddAgentPopup.vue?vue&type=template&id=151857a8"
import script from "./AddAgentPopup.vue?vue&type=script&lang=js"
export * from "./AddAgentPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__